import React, { PropsWithChildren, useLayoutEffect } from "react"

import { defaultSkin } from "./defaultSkin"
import { SkinsService } from "./types"
import { useCustomerInfo } from "../../../CustomerInfo"


export const WithCustomerCssSkins = ({
                                       children,
                                       service
                                     }: PropsWithChildren & { service: SkinsService }) => {
  const { data } = useCustomerInfo()
  const skinSource = data?.skin

  useLayoutEffect(() => {
    if (!data) return

    appendCssStyles(defaultSkin.styles, { id: "default-skin" })
    !!skinSource ? service.getSkin(skinSource).then(appendCssStyles).catch(console.error) : appendCssStyles("")

  }, [skinSource])

  return <>{children}</>
}

function appendCssStyles(styles: string, options?: { id?: string }) {
  const html = document.querySelector("html")!
  const styleElement = getSkinsElement(options?.id)
  styleElement.innerText = styles
  html.appendChild(styleElement)
}

function getSkinsElement(id?: string) {
  const SKIN_ID = "custom-skin"
  return document.getElementById(id ?? SKIN_ID) ?? Object.assign(document.createElement("style"), { id: id ?? SKIN_ID })
}
